module.exports = __webpack_public_path__ + "img/whisper.490e30b5.png";